<template>
  <div class="knowledge-base-page">
    <div class="header">
      <span class="back-arrow" @click="goBack">
        <img
          src="@/assets/svg/Arrow_Back.svg"
          alt="back"
          style="width: 6.51vw; height: 6.51vw;"
        />
      </span>

      <h1 class="page-title">知识库</h1>
      <div class="header-right"></div>
      <!-- For alignment -->
    </div>

    <div class="content-wrapper">
      <!-- Directly render categories and their children -->
      <section
        v-for="category in knowledgeData"
        :key="category.unique_code"
        class="category-section"
      >
        <h2 class="category-title">{{ category.name }}</h2>
        <div class="cards-grid">
          <!-- Directly render child cards -->
          <div
            v-for="child in category.child"
            :key="child.unique_code"
            class="content-card"
            @click="handleCardClick(child)"
            :style="{ backgroundImage: `url(${child.poster})` }"
          >
            <div class="card-content">
              <span class="card-text">{{ child.name }}</span>
            </div>
          </div>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import { getKonwledgeList } from '@/api/hb';

export default {
  name: 'KnowledgeBasePage',
  data() {
    return {
      knowledgeData: [],
    };
  },
  computed: {
    webInfo() {
      return this.$store.state.webInfo;
    },
  },
  watch: {
    // 监听 webInfo 的变化,确保 service_code 存在后再加载数据
    'webInfo.service_code': {
      handler(newVal) {
        if (newVal && this.knowledgeData.length === 0) {
          // 使用 nextTick 确保在下一个 DOM 更新周期执行
          this.$nextTick(() => {
            this.getKonwledgeList();
          });
        }
      },
      immediate: true, // 立即执行一次,如果 service_code 已存在(从 Cookie 加载)
    },
  },
  created() {
    // 如果 service_code 已经存在(刷新或二次进入),直接加载
    // 这里保留 created 调用是为了向后兼容
    if (this.webInfo.service_code) {
      this.getKonwledgeList();
    }
    // 如果不存在,watch 会在 service_code 设置后自动触发
  },
  methods: {
    goBack() {
      // Add your back navigation logic here.
      // For example, if using vue-router:
      // this.$router.go(-1);
      console.log('Navigating back...');

      // 使用浏览器的回退，回到图书馆工作台
      window.history.back();
    },
    handleCardClick(card) {
      console.log('Card clicked:', card.name, 'Code:', card.unique_code);
      this.$router.push({
        name: 'knowledgeLibDetail',
        params: { id: card.unique_code },
      });
    },
    async getKonwledgeList() {
      const { service_code } = this.webInfo;
      if (!service_code) {
        return;
      }
      try {
        const data = await getKonwledgeList({
          service_code: this.webInfo.service_code,
          tag: 5,
        });
        this.knowledgeData = data;
      } catch (err) {
        console.log(err);
      }
    },
  },
};
</script>

<style lang="less" scoped>
/* Base styling */
.knowledge-base-page {
  width: 100vw;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica,
    Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol';
  box-sizing: border-box;
  background-color: #f8f9fa;
  /* Light background */
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

/* Header */
.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 3.72vw 4.65vw;
  /* 16px 20px */
  background-color: #fff;
  // border-bottom: 1px solid #e0e0e0;
  position: sticky;
  /* Keep header at the top */
  top: 0;
  z-index: 100;
}

.back-arrow {
  font-size: 6.51vw;
  /* ~28px */
  cursor: pointer;
  color: #333;
  display: flex;
  align-items: center;
  line-height: 1;
}

.back-arrow:hover {
  color: #007bff;
  /* Optional hover effect */
}

.page-title {
  font-size: 4.65vw;
  /* ~20px */
  font-weight: bold;
  color: #333;
  margin: 0;
}

.header-right {
  width: 6.51vw;
  /* To balance the layout if no right element exists */
}

/* Content Wrapper */
.content-wrapper {
  flex-grow: 1;
  padding: 4.65vw;
  /* Adjust max-width based on your PC project design, e.g., if simulating mobile */
  max-width: 430px;
  /* Set to 430px as per your requirement for emulation */
  margin: 0 auto;
  /* Center the content */
  width: 100%;
  /* Ensure it takes full available width up to max-width */
}

/* Category Section */
.category-section {
  margin-bottom: 7.44vw;
}

.category-title {
  font-size: 5.2vw;
  /* ~24px */
  font-weight: bold;
  color: #333;
  margin-bottom: 3.72vw;
  padding-left: 1.86vw;
}

/* Grid for Cards */
.cards-grid {
  display: grid;
  /* 每行固定显示3个卡片 */
  grid-template-columns: repeat(3, 1fr);
  gap: 2.79vw;
  /* 卡片之间的间距 */
}

/* Content Card */
.content-card {
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #333;
  /* 默认背景色 */
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  border-radius: 10px;
  overflow: hidden;
  cursor: pointer;
  transition: transform 0.2s ease-in-out, box-shadow 0.2s ease-in-out;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  padding: 4vw;
  /* 内边距20px */
  // min-height: 120px; /* 设置最小高度 */
  position: relative;
}

.content-card::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.3);
  /* 半透明遮罩 */
  z-index: 1;
}

.content-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.15);
}

.card-content {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  z-index: 2;
  position: relative;
}

.card-text {
  font-size: 3.72vw;
  /* ~16px */
  font-weight: bold;
  color: white;
  text-align: center;
  /* 单行文字超出隐藏 */
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 100%;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.5);
  /* 文字阴影增强可读性 */
}

/* If you have dynamic content and want to ensure text fits */
/* You might need to adjust font-size or line-height based on text length if it varies a lot. */
/* For now, word-break should handle most cases. */

/* Override global min-width for mobile devices */
.knowledge-base-page {
  width: 100vw;
  overflow-x: hidden;
}
</style>
